import { render } from "./SalesQueue.vue?vue&type=template&id=22a895b2"
import script from "./SalesQueue.vue?vue&type=script&lang=js"
export * from "./SalesQueue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__